export default __webpack_public_path__ + "static/media/desert-safari.a79f8bcc.avif";